precision highp float;

float random(in vec2 st);
float noise2d(in vec2 st);
float noise2d(in float d1, in float d2);
float noise4d(in vec4 st);
vec2 getLatLng(in vec3 position, in float sphereRadius);

uniform float iTime;
uniform float uScroll;

varying vec2 uv; // [-1, 1]

const vec3 BLACK = vec3(0.0, 0.0, 0.0);

const float EARTH_ROTATION_ANGULAR_SPEED = 0.00007292115;

void main() {
    vec2 vUv = uv;
    float scrollValue = uScroll;
    vUv /= scrollValue;

    float details = 2.0;
    float speedRotation = EARTH_ROTATION_ANGULAR_SPEED;
    speedRotation /= scrollValue;

    float zSphere = sqrt(1.0 - pow(vUv.x, 2.0) - pow(vUv.y, 2.0));

    vec3 sphereCoords = vec3(vUv, zSphere);

    float rotationAngle = iTime * speedRotation;

    sphereCoords = vec3(sphereCoords.x * cos(rotationAngle) + sphereCoords.z * sin(rotationAngle), sphereCoords.y, -sphereCoords.x * sin(rotationAngle) + sphereCoords.z * cos(rotationAngle));

    float FACTOR_GLOBAL = 1.0;
    float coord4th = iTime * 0.01 / (500.0 * 1.0);

    vec4 p1 = vec4(sphereCoords, coord4th) * details * FACTOR_GLOBAL * 1.0;
    p1.z -= details * FACTOR_GLOBAL; // PRECISION FIX
    float noiseValue = noise4d(p1);

    float bisRotation = 0.01;
    vec3 sphereCoords2 = vec3(sphereCoords.x * cos(bisRotation) + sphereCoords.z * sin(bisRotation), sphereCoords.y, -sphereCoords.x * sin(bisRotation) + sphereCoords.z * cos(bisRotation));
    vec4 p1Bis = vec4(sphereCoords2, coord4th) * details * FACTOR_GLOBAL * 1.0;
    p1Bis.z -= details * FACTOR_GLOBAL; // PRECISION FIX
    float noiseValue2 = noise4d(p1Bis);

    const float RECURSION_LIMIT = 3.0;

    float curveValue = (noiseValue * 0.5 + 0.5) - (noiseValue2 * 0.5 + 0.5);

    vec3 noiseColor = mix(vec3(0.1, 0.0, 0.0) + 0.1, vec3(1.0, 0.5, 0.5), sign(curveValue) * noiseValue);

    // Edge shadow
    float isOutOfSphere = pow(vUv.x, 2.0) + pow(vUv.y, 2.0);

    vec3 finalColor = mix(noiseColor, BLACK, 1.0 - step(0.0, 1.0 - isOutOfSphere));
    finalColor = mix(finalColor, BLACK, 1.0 - zSphere);

    gl_FragColor = vec4(finalColor, 1.0);
}
